import React from 'react';

const WelcomeSection = () => {
  return (
    <section id="welcome" className="relative bg-black text-white py-16 sm:py-24 md:py-32">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          {/* Welcome Heading */}
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-6 sm:mb-8 leading-tight">
              WELCOME TO <span className="text-red-500">GAFF</span>
            </h2>
            <div className="w-16 sm:w-20 md:w-24 h-1 bg-red-500 mx-auto mb-8 sm:mb-10 md:mb-12"></div>
          </div>

          {/* Description */}
          <div className="mb-10 sm:mb-12 md:mb-16">
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-300 text-center max-w-4xl mx-auto px-2">
              A vibrant celebration of Asian cinema in the heart of <span className="text-white font-semibold">Guwahati City</span> - a cultural crossroads where stories, voices, and visions from across the continent come together.
            </p>
          </div>

          {/* Submissions Button */}
          <div className="flex justify-center">
            <a
              href="https://filmfreeway.com/GuwahatiAsianFilmFestival"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 bg-red-500 text-white text-sm sm:text-base md:text-lg font-bold uppercase tracking-wider rounded-lg hover:bg-red-600 transition-all duration-300 transform hover:scale-105 shadow-lg shadow-red-500/30 hover:shadow-red-500/50"
            >
              <span>SUBMISSIONS ARE OPEN NOW</span>
              <svg className="w-4 sm:w-5 h-4 sm:h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
    </section>
  );
};

export default WelcomeSection;
